import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const SLOT_EXPERIENCE = apiPromiseTypes('waitrose/slot_experience/', 'get');

export type SPECIFIC_BRANCH_MESSAGE_PARAMETERS = {
  addressId?: string;
  branchId?: string;
};
